export default __webpack_public_path__ + "static/media/reception.abbd1ba7.svg";